import { Box, Checkbox, FormControlLabel, TextField, Typography } from '@mui/material';
import type { AddStepFormState } from './types';

interface DurationFieldProps {
  hours: number;
  minutes: number;
  seconds: number;
  linkToPreviousStep?: boolean;
  linkedStepId?: string | null;
  durationAllow: boolean;
  durationRequired: boolean;
  onChange: (patch: Partial<Pick<AddStepFormState, 'durationHours' | 'durationMinutes' | 'durationSeconds' | 'linkToPreviousStep' | 'linkedStepId'>>) => void;
}

export function DurationField({
  hours, minutes, seconds,
  linkToPreviousStep,
  durationAllow, durationRequired, onChange,
}: DurationFieldProps) {
  if (!durationAllow) return null;

  return (
    <Box data-testid="duration-field">
      <Typography variant="subtitle2" sx={{ mb: 0.5, fontWeight: 600, color: '#204c77' }}>
        Duration {durationRequired && <span style={{ color: 'red' }}>*</span>}
      </Typography>
      <Box sx={{ display: 'flex', gap: 1, mt: 0.5 }}>
        <TextField label="HH" type="number" size="small" sx={{ width: 70 }}
          value={hours} onChange={(e) => onChange({ durationHours: Math.max(0, Number(e.target.value) || 0) })}
          slotProps={{ htmlInput: { min: 0 } }}
        />
        <TextField label="MM" type="number" size="small" sx={{ width: 70 }}
          value={minutes} onChange={(e) => onChange({ durationMinutes: Math.max(0, Math.min(59, Number(e.target.value) || 0)) })}
          slotProps={{ htmlInput: { min: 0, max: 59 } }}
        />
        <TextField label="SS" type="number" size="small" sx={{ width: 70 }}
          value={seconds} onChange={(e) => onChange({ durationSeconds: Math.max(0, Math.min(59, Number(e.target.value) || 0)) })}
          slotProps={{ htmlInput: { min: 0, max: 59 } }}
        />
      </Box>
      {/* <FormControlLabel
        sx={{ mt: 0.5 }}
        control={
          <Checkbox
            size="small"
            checked={linkToPreviousStep ?? false}
            onChange={(e) => onChange({ linkToPreviousStep: e.target.checked })}
          />
        }
        label={<Typography variant="caption">Link to previous step</Typography>}
      /> */}
    </Box>
  );
}
